@if (showSidebarToggle()) {
    <div class="flex items-center justify-center p-16 sm:hidden print:hidden">
        <button vds-button appearance="primary" type="button" (click)="showSidebar()">
            {{ toggleSidebarButtonLabel() }}
        </button>
    </div>
}
<ng-content></ng-content>
